import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import styles from './styles'
import NewScheduleCard from '../NewScheduleCard'
import Skeleton from '../Skeleton/Skeleton'

const LiveNow = ({
  error, isOverlay, channelData, isTvGuide,
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [loading, setLoading] = useState(true)
  const [channelFromQuery, setChannelFromQuerry] = useState(null)

  useEffect(() => {
    handleWindowResize()
    window.addEventListener('resize', debounce(handleWindowResize, 300))

    // Fetch the channel name from pathname
    const channelQueryParam = window.location.pathname.split('/')
    if (channelQueryParam.length > 2 && channelQueryParam[2]) {
      setChannelFromQuerry(channelQueryParam[2])
    } else {
      setChannelFromQuerry('stv')
    }
    return () => {
      window.removeEventListener('resize', debounce(handleWindowResize, 300))
    }
  })
  const handleWindowResize = () => {
    if (window.innerWidth <= 767) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
    setLoading(false)
  }
  if (error) return null
  const specificChannel = channelData?.find(channel => channel.channel === channelFromQuery)

  return (
    <section className={`OnNowOnNext ${isOverlay ? 'overlay' : ''}`}>

      {channelData && isOverlay && !isMobile && !loading && channelData.map(channel => (
        <NewScheduleCard
          key={channel.channel}
          isOverlay={isOverlay}
          link={`/live/${channel.channel}`}
          position={1}
          channel={channel.channel}
          {...channel}
          isTvGuide={isTvGuide}
        />
      ))}
      {loading && isTvGuide && (
        <div className="place-holder">
          <Skeleton classes="tvGuidePlaceholder" />
        </div>
      )}
      {isMobile && specificChannel && isTvGuide
        && (
          <div className={`visibility ${loading ? '' : 'loaded'}`}>
            <NewScheduleCard
              key={specificChannel.channel}
              isOverlay={isOverlay}
              link={`/live/${specificChannel.channel}`}
              position={1}
              channel={specificChannel.channel}
              {...specificChannel}
              isTvGuide={isTvGuide}
            />
          </div>
        )}

      <style jsx>{styles}</style>
    </section>
  )
}
LiveNow.propTypes = {
  channelData: PropTypes.arrayOf(PropTypes.object),
  isOverlay: PropTypes.bool,
  error: PropTypes.bool,
  isTvGuide: PropTypes.bool,
}
LiveNow.defaultProps = {
  error: false,
  isOverlay: false,
  channelData: [{}],
  isTvGuide: false,
}
export default LiveNow
